define((require) => {
    "use strict";

    const Marionette    = require("marionette");
    const FreeTransform = require("ui/experience/widgets/transformations/FreeTransform");

    /**
     * A coordinator/manager of all freeTransforms on the editor
     */
    const TransformerManager = Marionette.Controller.extend({

        _transfomers: [],

        add(transfomer) {
            this._transfomers.push(transfomer);
            this.listenTo(transfomer, FreeTransform.MOUSEDOWN, this._mouseDownEvent);
        },

        remove(transfomer) {
            this._transfomers.forEach((item, index) => {
                if (item.cid === transfomer.cid) {
                    this._transfomers.splice(index, 1);
                }
            });
        },

        getLength() {
            return this._transfomers.length;
        },

        /**
         * Handles a click event on a scene, which should deselect any selected widgets on other scenes
         * @param target   selected target
         * @param freeTransform the free transform for the scene
         * @private
         */
        _mouseDownEvent(target, freeTransform) {
            this._transfomers.forEach((transfomer) => {
                if (freeTransform.cid !== transfomer.cid && transfomer.hasTarget()) {
                    transfomer.deselect();
                }
            });
        }
    });

    // A singleton
    return new TransformerManager();
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/TransformerManager.js